import defaultTheme from './defaultTheme';
const samsClubTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0062a4', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0062a4', background: '#0062a4' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0062a4' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0062a4', border: '#0062a4', background: '#0062a4' }), field: {
        focus: '#0062a4',
        label: '#0062a4',
        icon: '#0062a4',
    } });
export default samsClubTheme;
